<div class="px-5 py-4">
    <div class="w-100 d-flex align-items-center justify-content-between">
        <div class="text-18-500-150 text-c4">{{'Edit quiz settings' | translate}}</div>
        <img class="c-pointer" width="16" (click)="close()" src="assets/icons/close.svg" alt="close_icon">
    </div>
    <app-game-settings [isDialog]="true" (submission)="onGameSettingsChange($event)"></app-game-settings>
</div>
